import { dateFormat } from '../../../../../../../shared/constants/apiDateFormat';
import { getFormattedDateInTz } from '../../../../../../../shared/utils/timezoneUtils/getFormattedDateInTz';
import { ChallengeImportantDatesFormValues } from '../../../../../../interfaces/ChallengeFormValues';
import { ChallengeImportantDatesSection } from '../../../../../../interfaces/SaveChallengeInfo';
import { challengeService } from '../../../../../../services/challengeService';

const getDate = (date: string | null, tz: string) => {
  return date ? getFormattedDateInTz(date, tz, dateFormat) : null;
};

const transformImportantDatesToFormValues = (
  importantDates: ChallengeImportantDatesSection,
): { importantDates: ChallengeImportantDatesFormValues } => {
  if (!importantDates.timeZone) {
    return {
      importantDates: {
        timeZone: null,
        startDate: null,
        endDate: null,
        registrationStartDate: null,
        registrationEndDate: null,
        firstScanStartDate: null,
        firstScanEndDate: null,
        lastScanStartDate: null,
        lastScanEndDate: null,
      },
    };
  }

  return {
    importantDates: {
      timeZone: importantDates.timeZone,
      startDate: getDate(importantDates.startDate, importantDates.timeZone),
      endDate: getDate(importantDates.endDate, importantDates.timeZone),
      registrationStartDate: getDate(
        importantDates.registrationStartDate,
        importantDates.timeZone,
      ),
      registrationEndDate: getDate(
        importantDates.registrationEndDate,
        importantDates.timeZone,
      ),
      firstScanStartDate: getDate(
        importantDates.firstScanStartDate,
        importantDates.timeZone,
      ),
      firstScanEndDate: getDate(importantDates.firstScanEndDate, importantDates.timeZone),
      lastScanStartDate: getDate(
        importantDates.lastScanStartDate,
        importantDates.timeZone,
      ),
      lastScanEndDate: getDate(importantDates.lastScanEndDate, importantDates.timeZone),
    },
  };
};

export const getImportantDatesFormValue = async (
  challengeId: number,
): Promise<{ importantDates: ChallengeImportantDatesFormValues }> => {
  const importantDates = await challengeService.getChallengeImportantDates(challengeId);
  return transformImportantDatesToFormValues(importantDates);
};
